
export default {
  name: 'DedicatedSupport',
  data() {
    return {
      supportFeatures: [
        {
          id: 1,
          title: 'Direct Tutor Access',
          description: "You'll be paired with a named tutor you can contact directly through our support system – real people, real help, when you need it."
        },
        {
          id: 2,
          title: 'Personalised Feedback',
          description: 'Your assignments are marked by your tutor and returned within 48 hours, giving you clear and actionable feedback to help you move forward.'
        },
        {
          id: 3,
          title: 'Grammar Support',
          description: 'Got a question during your self-study grammar module? Our support team is here to help you along the way.'
        },
        {
          id: 4,
          title: 'Consistent Guidance',
          description: "You'll work with the same tutor from start to finish. All your support is personal, consistent, and tailored to your progress."
        }
      ],
      tutors: [
        {
          id: 1,
          name: 'Thomas',
          role: '35+ years’',
          image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Thomas.jpg'
        },
        {
          id: 2,
          name: 'Angie',
          role: '20+ years’',
          image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Angie.jpg'
        },
        {
          id: 3,
          name: 'Dee',
          role: '45+ years’',
          image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Dee.jpg'
        },
        {
          id: 4,
          name: 'Fiona',
          role: '30+ years’',
          image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Fiona.jpg'
        },
        {
          id: 5,
          name: 'Alex',
          role: '30+ years’',
          image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/Alex-1.jpg'
        }
      ],
      resources: [
        {
          id: 1,
          title: 'Expert Advice',
          description: 'Get ongoing guidance from experienced TEFL advisors.',
          iconPath: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
        },
        {
          id: 2,
          title: 'Webinars & Workshops',
          description: 'Stay up-to-date with industry trends and keep improving your skills.',
          iconPath: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z'
        },
        {
          id: 3,
          title: 'Job Support & CV Help',
          description: "We'll help you perfect your CV and find the right teaching job.",
          iconPath: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
        },
        {
          id: 4,
          title: 'A Global Community',
          description: 'Become part of a thriving community of graduates and TEFL teachers.',
          iconPath: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
        }
      ]
    }
  }
}
